$.fn.Quantity = function() {
  let self = this

  if (self.data('quantity-field')) {
    return self.data('quantity-field')
  }

  self.el = {
    wrapper: undefined,
    minus: undefined,
    plus: undefined,
  }

  self.incrementValue = function(value) {
    self.val(Math.max(parseInt(self.val()) + value, 0))
    self.trigger('change')
    return false
  }

  self.validate = function() {
    let value = parseInt(self.val())
    if (isNaN(value)) {
      value = 1
    }
    if (value === self.min) {
      // bypass
    } else if (!value || value == undefined) {
      value = 1
    }
    if (value < self.min) {
      value = self.min
    }
    if (value > self.max) {
      value = self.max
    }
    self.val(value)
  }

  self.initialize_input = function() {
    self.el.wrapper = $('<div class="quantity-field">')
    self.el.minus = $('<a class="quantity-field__minus">-</a>')
    self.el.plus = $('<a class="quantity-field__plus">+</a>')
    self.addClass('quantity-field__input').wrap(self.el.wrapper)
    self.attr('type', 'number') // fix for WC forcing "hidden" field type
    self.el.minus.insertBefore(self)
    self.el.plus.insertAfter(self)
  }

  self.initialize_limits = function() {
    self.min = parseInt(self.attr('min'), 10)
    self.max = parseInt(self.attr('max'), 10)
    self.validate()
  }

  self.initialize_events = function() {
    self.el.plus.on('click', function() {
      self.incrementValue(1)
    })
    self.el.minus.on('click', function() {
      self.incrementValue(-1)
    })
    self.on('change', self.validate)
  }

  return function() {
    self.initialize_input()
    self.initialize_limits()
    self.initialize_events()
    self.data('quantity-field', self)
    return self
  }()
}
